/**
 *
 * Base
 *
 */


import { Fancybox } from 'Fancybox';

Fancybox.bind( '[data-fancybox]', {
	buttons: [ 'close' ],
	focus: false,
	hash: false
} );
